module.exports = __webpack_public_path__ + "fonts/Poppins-MediumItalic.cf5ba39d.ttf";